import { memo } from "react";

// components
import { Stack, Divider } from "@mui/material";

// utils
import { renderIcon } from "utils/helpers/typeKitchen";

// styled
import styled from "styled-components";

const SidebarStepSelectRestaurant = ({ 
  restaurants = [], 
  loading = false,
  selectRestaurant = () => { },
}) => (
  <Stack
    divider={<Divider flexItem />}
    spacing={1}
    height="100%"
    width="100%"
    justifyContent="space-evenly"
    alignItems="center"
    bgcolor="transparent"
  >
    {restaurants.map(({ id, code, name }) => (
      <Stack
        as={Restaurant}
        key={id}
        direction="row"
        onClick={selectRestaurant.bind(null, code)}
        disabled={loading}
      >
        <RestaurantIcon src={renderIcon(code)} />
        <h2>{name}</h2>
      </Stack>
    ))}
  </Stack>
);

const RestaurantIcon = styled.img`
    display: flex;
    align-items: center;
    margin-right: 10px;
    max-width: 54px;
`;

const Restaurant = styled.button`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background-color: transparent;
`;

export default memo(SidebarStepSelectRestaurant);
